import { Identifier } from 'src/types/utilityTypes';

import { Capability } from './_types';

export const getCapability = (
  capabilities: Capability[],
  id: Identifier,
  capabilityOnType: Capability['capabilityOnType']
) => {
  return (capabilities || []).find(
    (capability) =>
      capability.capabilityOnType === capabilityOnType &&
      capability.capabilityOnId === id
  );
};
